var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCircleCheckmark = function SvgCircleCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09 0a7.091 7.091 0 1 1 .001 14.183A7.091 7.091 0 0 1 7.09 0zm0 1.182A5.909 5.909 0 1 0 7.092 13 5.909 5.909 0 0 0 7.09 1.182zm2.737 3.963c.23.23.23.605 0 .836L6.902 8.906a.576.576 0 0 1-.19.127.59.59 0 0 1-.962.19L4.558 8.025a.59.59 0 1 1 .834-.836h.001l.775.778 2.823-2.822a.593.593 0 0 1 .836 0z"
  })));
};

export default SvgCircleCheckmark;